export const TABLES_IDS = {
  TENDER_TABLE_ID: 'tender-list',
  INCOMING_TENDER_TABLE_ID: 'incoming-tender-list',
  PROJECT_TABLE_ID: 'project-table-list',
};

export default TABLES_IDS;
